module.exports = __webpack_public_path__ + "static/media/authentication.700303f4.png";